// src/api/axios.js
import axios from "axios";

/* ------------------------------------------------------------
   🌍 BASE URL (WORKS FOR BOTH VITE & CREATE-REACT-APP)
------------------------------------------------------------ */
const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000/api"
    : "https://backend.sacmtb.com/api";

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
});

console.log("🔗 API Base URL:", BASE_URL);

// Debug log (Helps detect wrong URLs)
console.log("🔗 API Base URL:", API.defaults.baseURL);

/* ------------------------------------------------------------
   🔒 TOKEN INTERCEPTOR  (Fixed)
------------------------------------------------------------ */
API.interceptors.request.use(
  (config) => {
    try {
      const isFormData =
        typeof FormData !== "undefined" &&
        config.data instanceof FormData;

      // Let browser set multipart boundary
      if (isFormData) {
        if (typeof config.headers.delete === "function") {
          config.headers.delete("Content-Type");
        } else {
          delete config.headers["Content-Type"];
        }
      }

      const admin =
        JSON.parse(localStorage.getItem("admin") || "{}");

      const user =
        JSON.parse(localStorage.getItem("user") || "{}");

      const token =
        admin?.token ||
        user?.token ||
        localStorage.getItem("token");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      console.error("Token Interceptor Error:", err);
    }

    return config;
  },
  (error) => Promise.reject(error)
);
API.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401) {
        localStorage.removeItem("admin");
        localStorage.removeItem("user");
        localStorage.removeItem("token");

        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }

      if (status === 404) {
        console.error("❌ API Route Not Found");
      }

      if (status === 500) {
        console.error("🔥 Server Error", error.response.data);
      }
    } else if (error.request) {
      console.error("🌐 Backend not reachable");
    } else {
      console.error(error.message);
    }

    return Promise.reject(error);
  }
);

/* ------------------------------------------------------------
   🔐 AUTH
------------------------------------------------------------ */
export const registerUser = (data) => API.post("/users/register", data);
export const verifyEmailOTP = (data) => API.post("/users/verify-otp", data);
export const loginUser = (data) => API.post("/users/login", data);
export const googleLogin = (token) =>
  API.post("/users/google-login", { token });

export const forgotPassword = (email) =>
  API.post("/users/forgot-password", { email });

export const resetPassword = (data) => API.post("/users/reset-password", data);

/* ------------------------------------------------------------
   👤 USER PROFILE
------------------------------------------------------------ */
export const getUserProfile = () => API.get("/users/profile");
export const updateUserProfile = (data) => API.put("/users/profile", data);

/* ------------------------------------------------------------
   🧾 ORDERS (COD ONLY)
------------------------------------------------------------ */
export const createOrder = (data) => API.post("/orders/create", data);
export const getCustomerOrders = () => API.get("/orders/myorders");

export const getAllOrders = () => API.get("/orders");
export const updateOrderStatus = (orderId, data) =>
  API.put(`/orders/${orderId}/status`, data);

export const getOrderById = (orderId) => API.get(`/orders/${orderId}`);

/* ------------------------------------------------------------
   💳 RAZORPAY PAYMENT (ONLINE)
------------------------------------------------------------ */
export const createRazorpayOrder = (data) => {
  console.log("📤 Sending Razorpay create-order request:", data);
  return API.post("/payments/create-order", data);
};

export const verifyRazorpayPayment = (data) => {
  console.log("📤 Sending Razorpay verify request:", data);
  return API.post("/payments/verify", data);
};

/* ------------------------------------------------------------
   📝 REVIEWS
------------------------------------------------------------ */
export const getAllReviews = () => API.get("/reviews");
export const addReview = (data) => API.post("/reviews", data);
export const likeReview = (id) => API.post(`/reviews/${id}/like`);
export const unlikeReview = (id) => API.post(`/reviews/${id}/unlike`);

/* ------------------------------------------------------------
   🧑‍💼 ADMIN PANEL
------------------------------------------------------------ */
export const getDashboardStats = () => API.get("/admin/stats");
export const getAllUsers = () => API.get("/users");

export const blockUser = (id) => API.put(`/admin/users/${id}/block`);
export const unblockUser = (id) => API.put(`/admin/users/${id}/unblock`);

/* ------------------------------------------------------------
   📦 PRODUCTS
------------------------------------------------------------ */
export const getProducts = () => API.get("/products");
export const getProductById = (id) => API.get(`/products/${id}`);

/* ------------------------------------------------------------
   📤 UPLOADS
------------------------------------------------------------ */
export const uploadFile = (formData) =>
  API.post("/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export default API;
